//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.Optional
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String

public data class InspectionMediaDtoInput(
  public val id: Any,
  public val fileName: String,
  public val originalFileName: String,
  public val size: Int,
  public val fileUploaded: Optional<Boolean?> = Optional.Absent,
  public val fileUrl: Optional<String?> = Optional.Absent,
  public val thumbnailUrl: Optional<String?> = Optional.Absent,
)
